import React, { useEffect, useRef, useState } from 'react';
import { FontIcon } from 'react-md';
import styled from 'styled-components';

import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import debounce from 'lodash';
import get from 'lodash/get';

import { CSSTransition, TransitionGroup } from 'react-transition-group';

import {
    askQuestion,
    calcTimeDifference,
    likeQuestion,
    saveQuestion,
    toggleQuestionLike,
} from '../../../../services/QuestionsAndAnswersService';

import InputMessageComponent from '../../../../../Talk/components/InputMessageComponent';
import Dropdown from '../../../common/Dropdown';

import WarningDialog from '../../../common/WarningDialog';
import QuestionModal from './QuestionModal';
import VisibilityToaster from '../common/VisibilityToaster';
import { useVMState } from '../../../../containers/main';
import { SORT_QUESTIONS_BY } from '../index';
import NoQuestionsImage from '../../../../../../../../assets/images/no-questions.png';
import toast from 'toasted-notes';
import NotificationToast from '../../../../../../../../components/General/NotificationToast';
import { getString } from '../../../../../../../../services/api/store';
import {
    LikesContainer,
    QuestionAndTimeContainer,
    QuestionSenderName,
    StyledFavoriteIcon,
} from '../../../../../../../VirtualSession/components/userInteraction/questionsAndAnswers/QuestionsAndAnswers';
import { useTheme } from '../../../../../../../../components/Theme/ThemeContext';

const Wrapper = styled.div`
    height: ${props =>
        props.isfirefox && props.windowheight
            ? 'calc(100vh - ' + (props.windowheight < 700 ? '400px)' : '580px)')
            : '100%'};
    overflow: hidden;
    position: relative;
`;

const QuestionWrapper = styled.div`
    border-radius: 8px;
    ${props =>
        props.transparent
            ? 'background-color: transparent;'
            : `background-color: ${props.backgroundColor};
        padding: 12px 16px 14px 12px;
        cursor: pointer;
        `}
    ${props => props.isHovered && 'box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2)'};
    margin: 8px 0;
    overflow: hidden;
    justify-content: space-between;
    font-family: 'Cabin', sans-serif;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    color: rgba(0, 0, 0, 0.87);
    white-space: pre-wrap;
    word-break: break-word;
`;

const AnimatedQuestionWrapper = styled(QuestionWrapper)`
    animation-fill-mode: both;
    transition: max-height 300ms, opacity 300ms;
    position: relative;

    &.exit {
        max-height: 0;
        opacity: 0;
        padding: 0 8px 0 16px;
    }
`;

const VisibilityIconWrapper = styled.div`
    cursor: pointer;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        color: ${props => props.color} !important;
    }
    &:hover {
        background: rgba(0, 0, 0, 0.1);
    }

    &:active {
        background: rgba(0, 0, 0, 0.2);
    }
`;

const ActionButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    align-content: center;
    position: absolute;
    right: ${props => (props.new ? 48 : 8)}px;
`;

const LikeIconContainer = styled.div`
    color: rgba(0, 0, 0, 0.87);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 36px;
    width: 36px;
    border-radius: 50%;
    margin-left: 8px;

    &:hover {
        background-color: rgba(0, 0, 0, 0.04);
    }

    &:active {
        background-color: rgba(0, 0, 0, 0.12);
    }
`;

const FlexContainer = styled.div`
    display: flex;
    align-items: ${props => props.alignitems};
    justify-content: ${props => props.justifycontent};
    flex-wrap: ${props => props.wrap};
`;

const Time = styled.div`
    margin-left: 8px;
`;

const ActionsWrapper = styled.div`
    position: relative;
    border-radius: 50%;
    cursor: pointer;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(0, 0, 0, 0.54);

    &:hover {
        background: rgba(0, 0, 0, 0.1);
    }
    &:active {
        background: rgba(0, 0, 0, 0.2);
    }
`;

const PlaceholderImageWrapper = styled.div`
    align-items: center;
    text-align: center;
    justify-content: center;
    padding: 20px;
    height: 100%;
    display: flex;
    flex-direction: column;

    span {
        font-family: 'Roboto', sans-serif;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: normal;
        color: rgba(0, 0, 0, 0.87);
    }
`;

export const QuestionsContainer = styled.div`
    height: ${props => (props.mobile === 'true' ? '59%' : 'calc(100% - 64px)')};
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    overflow-y: scroll;
`;

const ScrollableWrapper = styled.div`
    padding: 0 16px;
    height: calc(100% + 32px);
    overflow-y: auto;
`;

const PlaceholderImage = styled.img`
    width: 250px;
    height: 200px;
`;

const StyledChip = styled.p`
    text-align: center !important;
    font-family: 'Roboto', sans-serif;
    font-size: 8px !important;
    font-weight: bold !important;
    color: #fff !important;
    background-color: #1fa294;
    border-radius: 18px;
    width: 26px !important;
    height: 12px !important;
    line-height: 13px !important;
    white-space: nowrap;
    margin-left: auto;
`;

const TextFieldWrapper = styled.div`
    background-color: #ffffff;
    width: 100%;
    border-radius: 8px;
    ${props =>
        props.isfirefox
            ? `
        bottom: 110px;
        position: relative;
        display: inline-block;
        content: '';
    `
            : `
        bottom: 0;
        position: absolute !important;
    `}
`;

const Tooltip = styled.div`
    position: absolute;
    transform: translateY(-8px);
    background-color: #292929;
    border-radius: 4px;
    width: 125px;
    text-align: center;
    right: 0;
    z-index: 2;
`;

const QuestionItemDetailsWrapper = styled(FlexContainer)`
    width: 100%;
`;

const TooltipText = styled.p`
    font-size: 12px !important;
    color: #fff !important;
    font-family: Roboto, sans-serif;
`;

export const Flex = styled.div`
    display: flex;
    align-items: ${props => props.alignItems};
`;

const ConfirmationText = styled.span`
    font-style: italic;
    font-size: 14px !important;
    margin: 0 4px 8px 4px !important;
    padding-left: 12px !important;
    color: ${props => (props.error ? '#d50000' : 'rgba(0, 0, 0, 0.87)')} !important;
    display: inherit;
`;

const MAX_QUESTION_SIZE = 250;

const QuestionsAndAnswers = ({
    questions,
    fetchQuestions,
    controls,
    questionSetsId,
    showInvisible,
    showVisible,
    orderBy,
    nonVirtualQA,
}) => {
    const [currentQuestionInfo, setCurrentQuestionInfo] = useState(null);
    const [currentQuestionToEdit, setCurrentQuestionToEdit] = useState(null);
    const [currentQuestionToDelete, setCurrentQuestionToDelete] = useState(null);
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const [displayActions, setDisplayActions] = useState(null);
    const [sortedQuestions, setSortedQuestions] = useState(questions);
    const [question, setQuestion] = useState('');
    const [displayTooltip, setDisplayTooltip] = useState(null);
    const isFirefox = typeof InstallTrigger !== 'undefined';
    const isSubmittingQuestion = useRef(false);
    const isSendingRequest = useRef(false);
    const areQuestionsLoading = useRef(true);
    const { theme } = useTheme();

    const stateCtx = useVMState();
    const { virtualEventSession, virtualEventUser: currentUser, externalObject, socket } = stateCtx;

    let areQuestionsEnabled = get(virtualEventSession, 'data.showQA') || false;
    if (nonVirtualQA) {
        areQuestionsEnabled = true;
    }

    const handleResize = debounce(() => {
        setWindowHeight(window.innerHeight);
    }, 500);

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const sortQuestionsByDate = questions => {
        const sorted = questions.sort(
            (q1, q2) =>
                new Date(12 && q2.createdAt ? q2.createdAt : null) -
                new Date(q1 && q1.createdAt ? q1.createdAt : null),
        );

        return sorted;
    };

    const sortQuestionsByLikesAndDate = questions => {
        const sorted = questions.sort((q1, q2) =>
            getQuestionLikes(q1) > getQuestionLikes(q2)
                ? -1
                : getQuestionLikes(q1) < getQuestionLikes(q2)
                ? 1
                : new Date(q2 && q2.createdAt ? q2.createdAt : null) -
                  new Date(q1 && q1.createdAt ? q1.createdAt : null),
        );

        return sorted;
    };

    const getNewAndOldQuestions = () => {
        areQuestionsLoading.current = true;
        let newQuestions = questions.filter(q =>
            controls ? q.newQuestion : q.newQuestionForSpeaker,
        );
        let visibleNewQuestions = newQuestions.filter(q => q.visible && showVisible);
        let invisibleNewQuestions = newQuestions.filter(q => !q.visible && showInvisible);
        visibleNewQuestions =
            orderBy === SORT_QUESTIONS_BY.NEWEST_FIRST
                ? sortQuestionsByDate(visibleNewQuestions)
                : sortQuestionsByLikesAndDate(visibleNewQuestions);
        invisibleNewQuestions =
            orderBy === SORT_QUESTIONS_BY.NEWEST_FIRST
                ? sortQuestionsByDate(invisibleNewQuestions)
                : sortQuestionsByLikesAndDate(invisibleNewQuestions);
        newQuestions = Array.from(new Set(visibleNewQuestions.concat(invisibleNewQuestions)));

        let oldQuestions = questions.filter(q =>
            controls ? !q.newQuestion : !q.newQuestionForSpeaker,
        );
        let visibleOldQuestions = oldQuestions.filter(q => q.visible && showVisible);
        let invisibleOldQuestions = oldQuestions.filter(q => !q.visible && showInvisible);
        visibleOldQuestions =
            orderBy === SORT_QUESTIONS_BY.NEWEST_FIRST
                ? sortQuestionsByDate(visibleOldQuestions)
                : sortQuestionsByLikesAndDate(visibleOldQuestions);
        invisibleOldQuestions =
            orderBy === SORT_QUESTIONS_BY.NEWEST_FIRST
                ? sortQuestionsByDate(invisibleOldQuestions)
                : sortQuestionsByLikesAndDate(invisibleOldQuestions);
        oldQuestions = Array.from(new Set(visibleOldQuestions.concat(invisibleOldQuestions)));
        return { newQuestions, oldQuestions };
    };

    const setVisibleInvisibleSortedQuestions = oldQuestionsList => {
        const { newQuestions, oldQuestions } = getNewAndOldQuestions();
        const oldQuestionList = oldQuestionsList.filter(q => q && !q.newQuestion);

        if (oldQuestionList.length !== 0 && oldQuestions.length === oldQuestionList.length) {
            const likesMap = Array.from(new Set(newQuestions.concat(oldQuestions))).reduce(
                (acc, q) => {
                    acc[q.id] = { ...q };
                    return acc;
                },
                {},
            );
            const questionsWithUpdatedLikes = questions.map(q => likesMap[q.id]).filter(q => !!q);

            return Array.from(new Set(newQuestions.concat(questionsWithUpdatedLikes)));
        }

        return Array.from(new Set(newQuestions.concat(oldQuestions)));
    };

    useEffect(() => {
        setSortedQuestions(oldQuestions => setVisibleInvisibleSortedQuestions(oldQuestions));
        areQuestionsLoading.current = false;
    }, [questions, showInvisible, showVisible, orderBy]);

    const toggleVisibility = async question => {
        await saveQuestion({
            ...question,
            visible: !question.visible,
        });

        const data = {};
        data.objectId = externalObject.data.id;
        socket.emit('setQuestions', data);
    };

    const onGetInfoClick = (e, question) => {
        e.stopPropagation();
        setCurrentQuestionInfo(question);
    };

    const onEditClick = (e, question) => {
        e.stopPropagation();
        setCurrentQuestionToEdit(question);
    };

    const onDeleteClick = (e, question) => {
        e.stopPropagation();
        setCurrentQuestionToDelete(question);
    };

    const onMainQuestionClick = async (e, question) => {
        e.stopPropagation();
        await saveQuestion({
            ...question,
            active: true,
        });

        const data = {};
        data.objectId = externalObject.data.id;
        socket.emit('setQuestions', data);
    };

    const onQuestionLike = async ({ QuestionLikes, id }) => {
        if (isSendingRequest.current) {
            return;
        }
        isSendingRequest.current = true;

        const questionLikeIndex = QuestionLikes.findIndex(
            ql => ql.UserId === currentUser.data.UserId,
        );

        const data = {
            active: questionLikeIndex !== -1 ? !QuestionLikes[questionLikeIndex].active : true,
            QuestionId: id,
            UserId: currentUser.data.UserId,
        };

        if (questionLikeIndex !== -1) {
            await toggleQuestionLike({
                questionLikeId: QuestionLikes[questionLikeIndex].id,
                data,
            });
        } else {
            await likeQuestion({ data });
        }

        const qdata = {};
        qdata.objectId = externalObject.data.id;
        socket.emit('setQuestions', qdata);

        isSendingRequest.current = false;
    };

    const onChange = text => {
        setQuestion(text);
    };

    const getQuestionLikes = question => question.QuestionLikes.filter(q => q.active).length;

    const onShowConfirmationText = success => {
        toast.notify(
            () => (
                <NotificationToast
                    title={success ? 'Question was sent' : 'Question was not sent'}
                    subtitle={
                        success
                            ? getString(
                                  'askQuestionSuccess',
                                  'It will appear in this list when the moderator decides to make it visible.',
                              )
                            : getString(
                                  'askQuestionFail',
                                  'Something went wrong sending your question',
                              )
                    }
                    icon={success ? 'check' : 'info'}
                />
            ),
            {
                position: 'top-right',
                duration: 5000,
            },
        );
    };

    const renderQuestions = () =>
        !areQuestionsLoading.current &&
        sortedQuestions.map(question => {
            if (!question) {
                return null;
            }

            const senderFirstName = get(question, 'User.firstName', '');
            const senderLastName = get(question, 'User.lastName', '');
            const senderFullName = `${senderFirstName} ${senderLastName}`;

            const questionDate = new Date(
                question && question.createdAt ? question.createdAt : null,
            );
            const iconToDisplay = question.visible ? (
                displayActions === question.id ? (
                    <VisibilityOffIcon />
                ) : (
                    <VisibilityIcon />
                )
            ) : displayActions === question.id ? (
                <VisibilityOutlinedIcon />
            ) : (
                <VisibilityOffOutlinedIcon />
            );
            let isQuestionLikedByCurrentUser = false;
            const questionLikes = get(question, 'QuestionLikes', []);
            const questionLikeIndex = questionLikes.findIndex(
                ql => ql.UserId === currentUser.data.UserId,
            );

            if (questionLikeIndex !== -1 && questionLikes[questionLikeIndex].active) {
                isQuestionLikedByCurrentUser = true;
            }

            return (
                <CSSTransition key={`question-${question.id}`} timeout={400}>
                    <React.Fragment key={`question-${question.id}`}>
                        <AnimatedQuestionWrapper
                            key={`question-${question.id}`}
                            data-qa={`qa-item-${question.id}`}
                            onMouseEnter={() => setDisplayActions(question.id)}
                            onMouseLeave={() => setDisplayActions(null)}
                            backgroundColor={'#f1f1f3'}
                            ishovered={displayActions === question.id}
                        >
                            <QuestionItemDetailsWrapper>
                                <LikesContainer data-qa={`qa-item-likes-${question.id}`}>
                                    <StyledFavoriteIcon
                                        color={
                                            (question.like && question.like.active && '#000000') ||
                                            'rgba(0, 0, 0, 0.87)'
                                        }
                                    >
                                        {'favorite'}
                                    </StyledFavoriteIcon>
                                    {getQuestionLikes(question)}
                                </LikesContainer>
                                <QuestionAndTimeContainer>
                                    <QuestionItemDetailsWrapper>
                                        <QuestionSenderName>{senderFullName}</QuestionSenderName>
                                        <Time>{calcTimeDifference(questionDate)}</Time>
                                        {question.newQuestion && (
                                            <StyledChip primary={theme.contrast}>NEW</StyledChip>
                                        )}
                                    </QuestionItemDetailsWrapper>
                                    <div>{question.question}</div>
                                </QuestionAndTimeContainer>
                                {controls && displayActions === question.id && (
                                    <ActionButtonContainer new={question.newQuestion}>
                                        <ActionsWrapper>
                                            <Dropdown
                                                customPosition={'top'}
                                                items={[
                                                    {
                                                        text: 'Get info',
                                                        icon: 'info',
                                                        onClick: e => onGetInfoClick(e, question),
                                                    },
                                                    {
                                                        text: 'Edit',
                                                        icon: 'edit',
                                                        onClick: e => onEditClick(e, question),
                                                    },
                                                    {
                                                        text: 'Delete',
                                                        icon: 'delete',
                                                        onClick: e => onDeleteClick(e, question),
                                                    },
                                                    {
                                                        text: 'Make main question',
                                                        icon: 'bookmark_border',
                                                        onClick: e =>
                                                            onMainQuestionClick(e, question),
                                                    },
                                                ]}
                                            />
                                        </ActionsWrapper>
                                        <VisibilityIconWrapper
                                            onClick={() => toggleVisibility(question)}
                                            onMouseEnter={() => setDisplayTooltip(question.id)}
                                            onMouseLeave={() => setDisplayTooltip(null)}
                                            data-qa={`${
                                                question.visible ? 'disable' : 'enable'
                                            }-qa-item-visibility-${question.id}`}
                                            color={
                                                displayActions === question.id || question.visible
                                                    ? 'rgba(0, 0, 0, 0.87)'
                                                    : 'rgba(0, 0, 0, 0.54)'
                                            }
                                        >
                                            {iconToDisplay}
                                        </VisibilityIconWrapper>
                                    </ActionButtonContainer>
                                )}
                                {!controls && displayActions === question.id && (
                                    <ActionButtonContainer>
                                        <LikeIconContainer
                                            onClick={() =>
                                                controls ? null : onQuestionLike(question)
                                            }
                                        >
                                            <FontIcon>
                                                {isQuestionLikedByCurrentUser
                                                    ? 'favorite'
                                                    : 'favorite_border'}
                                            </FontIcon>
                                        </LikeIconContainer>
                                    </ActionButtonContainer>
                                )}
                            </QuestionItemDetailsWrapper>
                        </AnimatedQuestionWrapper>
                        {displayTooltip && question.id === displayTooltip && (
                            <Tooltip
                                key={`tooltip-${question.id}`}
                                data-qa={`qa-item-${question.id}`}
                            >
                                <TooltipText>
                                    {question.visible
                                        ? 'Click to make invisible'
                                        : 'Click to make visible'}
                                </TooltipText>
                            </Tooltip>
                        )}
                    </React.Fragment>
                </CSSTransition>
            );
        });

    const onSubmitQuestion = async () => {
        if (isSubmittingQuestion.current === true) {
            return;
        }

        const currentQuestionAlreadyExists = sortedQuestions.find(
            item => item.question === question,
        );

        if (question && !currentQuestionAlreadyExists) {
            isSubmittingQuestion.current = true;

            try {
                await askQuestion({
                    questionSetId: questionSetsId,
                    question,
                });

                const data = {};
                data.objectId = externalObject.data.id;
                socket.emit('setQuestions', data);
            } catch (err) {
                onShowConfirmationText(false);
                console.log('Error: ', err);
            }

            isSubmittingQuestion.current = false;
        }

        setQuestion('');
        onShowConfirmationText(true);
    };

    const sender =
        currentQuestionInfo && currentQuestionInfo.User
            ? `${currentQuestionInfo.User.firstName} ${currentQuestionInfo.User.lastName}`
            : 'Anonymous';

    return (
        <Wrapper
            isfirefox={isFirefox ? 1 : undefined}
            windowheight={windowHeight}
            data-qa="qa-container"
            controls={controls}
        >
            <QuestionsContainer>
                {sortedQuestions.length === 0 && (
                    <PlaceholderImageWrapper>
                        <PlaceholderImage src={NoQuestionsImage} alt="No questions" />
                        <span>There are no questions yet</span>
                    </PlaceholderImageWrapper>
                )}
                {sortedQuestions.length !== 0 && (
                    <ScrollableWrapper>
                        <TransitionGroup style={{ width: '100%' }}>
                            {renderQuestions()}
                        </TransitionGroup>
                    </ScrollableWrapper>
                )}
            </QuestionsContainer>
            <TextFieldWrapper isfirefox={isFirefox ? 1 : 0}>
                <Flex alignItems={'center'}>
                    {areQuestionsEnabled ? (
                        <InputMessageComponent
                            sendMessage={onSubmitQuestion}
                            placeholder={'Ask a question'}
                            onChange={onChange}
                            maxChar={MAX_QUESTION_SIZE}
                        />
                    ) : (
                        <VisibilityToaster />
                    )}
                </Flex>
                {question.length > MAX_QUESTION_SIZE && (
                    <ConfirmationText
                        error
                    >{`${question.length}/${MAX_QUESTION_SIZE} characters`}</ConfirmationText>
                )}
            </TextFieldWrapper>
            {currentQuestionInfo && (
                <WarningDialog
                    open={true}
                    title="Question Info"
                    content={
                        <div>
                            <p>{`Sender: ${sender}`}</p>
                            <p>{`Creation date: ${new Date(
                                currentQuestionInfo.createdAt,
                            ).toUTCString()}`}</p>
                            <p>{`Last update: ${new Date(
                                currentQuestionInfo.updatedAt,
                            ).toUTCString()}`}</p>
                        </div>
                    }
                    onClose={() => setCurrentQuestionInfo(null)}
                    width={350}
                />
            )}
            <QuestionModal
                open={!!currentQuestionToEdit || !!currentQuestionToDelete}
                handleClose={() => {
                    setCurrentQuestionToEdit(null);
                    setCurrentQuestionToDelete(null);
                    fetchQuestions();
                }}
                handleSubmit={() => {
                    const data = {};
                    data.objectId = externalObject.data.id;
                    socket.emit('setQuestions', data);
                }}
                question={currentQuestionToEdit || currentQuestionToDelete}
                editModalType={!!currentQuestionToEdit}
            />
        </Wrapper>
    );
};

export default QuestionsAndAnswers;
